import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, RouterEvent, NavigationEnd } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { AuthJwtService } from '../../services/auth-jwt.service';

@Component({
  templateUrl: './login-jwt.component.html'
})
export class LoginJwtComponent implements OnInit {

  loginform: FormGroup;
  returnUrl: string | null = '';

  usuario: any = {
    username: '',
    password: ''
  };

  constructor(private router: Router,
    private route: ActivatedRoute,
    private authService: AuthJwtService,
  ) {
    this.loginform = new FormGroup({
      'username': new FormControl('', Validators.required),
      'password': new FormControl('', Validators.required)
    });

    if (this.router.url.startsWith('/login')) {
      this.authService.logout();
    }
  }

  ngOnInit() {
    this.router.events.subscribe(
      (event: NavigationEnd) => {
        if (event) {
          this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
        }
      }
    );
  }

  login() {
    if (this.loginform.invalid) return;

    Swal.fire({
      icon: 'info',
      text: 'Espere, por favor...',
      allowOutsideClick: false
    });
    Swal.showLoading();

    this.usuario = this.loginform.value;
    let authValues = { "User": this.usuario.username, "Password": this.usuario.password };
    this.authService.login(authValues).subscribe(() => {
      Swal.close();
      this.router.navigateByUrl(this.returnUrl || '/home');
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao aceder à bases de dados',
        text: 'Ocorreu um erro'
      });
    });
  }
}
